import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose, ExecutionResult } from 'react-apollo';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Mutations from '@api/graphql/mutations';
import ProductListAdForm from '../components/ProductListAdForm';
import { createProductListAdVariables, ProductListAdType, createProductListAd } from '@api/graphql/types';
import { ProductValueLabel } from "../components/ProductInput";
import { Paths } from '..';


type Props = {
} & InjectedIntlProps & RouteComponentProps;

interface State {
    formData: createProductListAdVariables;
    selectedProduct?: ProductValueLabel;
}

class ProductListAdCreate extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            formData: {
                name: '',
                banner_url: '',
                type: ProductListAdType.BANNER,
                image_url_desktop: '',
                image_url_mobile: '',
                is_active: true,
                active_from: null,
                active_to: null,
                urls: [],
            },
        };
    }

    private cleanUnusedVariables = (variables: createProductListAdVariables) => {
        if (variables.type === ProductListAdType.BANNER) {
            return {
                ...variables,
                product_id: null,
            };
        }
        return {
            ...variables,
            banner_url: null,
            image_url_desktop: null,
            image_url_mobile: null,
        };
    }

    private onFormChange = (formData: createProductListAdVariables) => {
        this.setState({ formData });
    }

    private onProductChange = (selectedProduct: ProductValueLabel) => {
        this.setState({
            formData: {
                ...this.state.formData,
                product_id: selectedProduct.value,
            },
            selectedProduct,
        });
    }

    public onSubmit = (variables: createProductListAdVariables) => {
        return GraphQLClient.mutate({
            mutation: Mutations.createProductListAd, variables: this.cleanUnusedVariables(variables),
        });
    }

    private onRedirectFunction = (response: ExecutionResult<createProductListAd>) => {
        const id = response.data ? response.data.createProductListAd.id : undefined;
        if (id) {
            return `${Paths.productListAd}/${id}`;
        }
        return undefined;
    }

    public render() {
        return (
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h5>{this.props.intl.formatMessage({id: 'module.productListAd.create.title'})}</h5>
                        </div>
                        <div className="ibox-content">
                            <ProductListAdForm
                                formData={this.state.formData}
                                selectedProduct={this.state.selectedProduct}
                                onSubmit={this.onSubmit}
                                onFormChange={this.onFormChange}
                                onProductChange={this.onProductChange}
                                redirectFunction={this.onRedirectFunction}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default compose(
    injectIntl,
    withRouter,
)(ProductListAdCreate);



// WEBPACK FOOTER //
// ./src/modules/ProductListAd/pages/ProductListAdCreate.tsx